<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormMedical1 }}</h2>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormMedical2 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Medical.PatientName" @input="validatePage('Medical', 'patientName')" />
                <div v-if="store.errors.Medical.PatientName" class="error">{{ store.lexicon[store.culture].PRFormMedical3 }}</div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice9 }} <span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Medical.IncidentDate" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy"></VueDatePicker>
                <!--<bootstrap-datetime-picker :options="dtPickerOptions" v-model="store.formData.Medical.IncidentDate"></bootstrap-datetime-picker>-->
                <div v-if="store.errors.Medical.IncidentDate" class="error">{{ store.lexicon[store.culture].PRBodyCam5 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormMedical6 }} <span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Medical.IncidentTime" time-picker auto-apply model-type="format" format="hh:mm aa" :is-24="false"></VueDatePicker>
                <!--<input type="text" class="form-control" v-model="store.formData.Medical.IncidentTime" @@input="validatePage('Medical', 'incidentTime')" @@blur="updateTimeOfIncident" />-->
                <div v-if="store.errors.Medical.IncidentTime" class="error">{{ store.lexicon[store.culture].PTCCTV8 }}</div>
            </div>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRFormMedical8 }} <span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Medical.IncidentLocation" @input="validatePage('Medical', 'incidentLocation')"></textarea>
            <div v-if="store.errors.Medical.IncidentLocation" class="error">{{ store.lexicon[store.culture].PTCCTV4 }}</div>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRFormMedical10 }}</label>
            <textarea type="text" class="form-control" v-model="store.formData.Medical.AssistanceLocation"></textarea>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>